var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:index},[_c('v-alert',{attrs:{"shaped":"","elevation":"5","dismissible":"","dense":"","type":_vm.getNotificationType(notification.type)}},[_vm._v(" "+_vm._s(notification.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }